// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3klag","dragIcon":"SortableItem_dragIcon__1csUF","disabled":"SortableItem_disabled__1yvMJ"};